import MicroModal from 'micromodal';
export class CommonModal {
    constructor() {
        this.init();
    }
    init() {
        MicroModal.init();
    }
}
